import { createSlice, } from '@reduxjs/toolkit';

const initialState = {
  arrAnsPart2: [],
  arrAnsPart3: []
};

const AnswerParts = createSlice({
  name: 'answer',
  initialState,
  reducers: {
    setArrAnswerPart2: (state, action) => {
      state.arrAnsPart2 = action.payload
    },
    setArrAnswerPart3: (state, action) => {
      state.arrAnsPart3 = action.payload
    },
  },
  extraReducers: {
  },
});

export const { setArrAnswerPart2, setArrAnswerPart3 } = AnswerParts.actions;

export default AnswerParts.reducer


